import { renderIsomorphicComponent, renderComponent } from "@quintype/framework/client/start";
import get from "lodash/get";

import { pickComponent } from "../isomorphic/pick-component";
import { Footer } from "../isomorphic/components/layouts/footer";
import { Header } from "../isomorphic/components/layouts/header";
import { NavbarSearch } from "../isomorphic/components/layouts/header/navbar-search";
import { NavBar } from "../isomorphic/components/layouts/header/nav-bar";
import LoadingIndicatorComponent from "../isomorphic/components/atoms/loading-indicator";

export function preRenderApplication(store) {
  const hydrate = { hydrate: !global.qtLoadedFromShell };
  const pageType = get(store.getState(), ["qt", "pageType"], null);

  if (pageType !== "user-login") {
    renderComponent(Header, "header-container", store, hydrate);
    global.qtLoadedFromShell && renderComponent(Footer, "footer", store, {
      ...hydrate,
      className: `${(pageType === "member-dashboard-page" || pageType === "home-page") ? "no-top-margin" : ""} ${pageType === "home-page" ? "no-top-padding" : ""}`.trim()
    });
    renderComponent(NavbarSearch, "search-bar", store, hydrate);
    renderComponent(NavBar, "nav-bar", store, hydrate);
  }
  renderComponent(LoadingIndicatorComponent, "loading-indicator", store);
}

// This is a separate file as everything from here on is hot reloaded when the app changes
export function renderApplication(store) {
  const enableAds = get(store.getState(), ["qt", "config", "ads-config", "dfp_ads", "enable_ads"]);
  const pageType = get(store.getState(), ["qt", "pageType"], null);
  const placeholderDelay = parseInt(
    get(store.getState(), ["qt", "config", "publisher-attributes", "placeholder_delay"])
  );

  renderIsomorphicComponent("container", store, pickComponent, {
    hydrate: !global.qtLoadedFromShell,
  });
}
